

export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_LOADING = 'SET_LOADING'
export const SET_USERID = 'SET_USERID'
export const SET_CHATID = 'SET_CHATID'
export const SET_USER = 'SET_USER'